/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* jshint expr: true */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        function articleHeight() {
          var maxHeight = 0;
          $(".article").css('height', 'auto');

          $(".article").each(function() {
            if ($(this).outerHeight() > maxHeight) {
              maxHeight = $(this).outerHeight();
            }
          });

          $(".article").outerHeight(maxHeight);
        }

        setTimeout(function() {
          articleHeight();
        }, 500);

        $(window).resize(function() {
          articleHeight();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        var deviceAgent = navigator.userAgent.toLowerCase();

        if (deviceAgent.match(/(android|blackberry|iphone|ipod|ipad|symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
          $('body').addClass('mobile');
        }

        if (!$('body').hasClass('mobile')) {
          $('#home-video').css('background-image', 'none');
        }

        // JavaScript to be fired on the home page
        function checkHeight() {
          var windowHeight = $(window).height();
          var carouselHeight;
          $('#home-carousel .item').css('height', windowHeight);
          //$('.home-screen').css('min-height', windowHeight);
        }

        checkHeight();
        $(window).resize(checkHeight);

        $('.carousel-arrow').click(function() {
          $('html,body').animate({
            scrollTop: $("#introduction").offset().top
          }, 'slow');
        });

        $("#service-carousel").carousel();

        $("#tubular-player").tubular({videoId: 'Iiy1amIBUnw', repeat: true, mute: true});

        var scrolling = false;
        var contentSections = $('.cd-section'),
          verticalNavigation = $('.cd-vertical-nav'),
          navigationItems = verticalNavigation.find('a'),
          navTrigger = $('.cd-nav-trigger'),
          scrollArrow = $('.cd-scroll-down');

        function updateSections() {
          var halfWindowHeight = $(window).height() / 2,
            scrollTop = $(window).scrollTop();
          contentSections.each(function() {
            var section = $(this),
              sectionId = section.attr('id'),
              navigationItem = navigationItems.filter('[href^="#' + sectionId + '"]');
            ((section.offset().top - halfWindowHeight < scrollTop) && (section.offset().top + section.height() - halfWindowHeight > scrollTop))
              ? navigationItem.addClass('active')
              : navigationItem.removeClass('active');
          });
          scrolling = false;
        }

        function checkScroll() {
          if (!scrolling) {
            scrolling = true;
            (!window.requestAnimationFrame)
              ? setTimeout(updateSections, 300)
              : window.requestAnimationFrame(updateSections);
          }
        }

        $(window).on('scroll', checkScroll);

        function smoothScroll(target) {
          $('body,html').animate({
            'scrollTop': target.offset().top
          }, 300);
        }

        //smooth scroll to the selected section
        verticalNavigation.on('click', 'a', function(event) {
          event.preventDefault();
          smoothScroll($(this.hash));
          verticalNavigation.removeClass('open');
        });

        //smooth scroll to the second section
        scrollArrow.on('click', function(event) {
          event.preventDefault();
          smoothScroll($(this.hash));
        });

        // open navigation if user clicks the .cd-nav-trigger - small devices only
        navTrigger.on('click', function(event) {
          event.preventDefault();
          verticalNavigation.toggleClass('open');
        });

        $('#home-image-carousel').carousel({
          interval: 1000 * 8
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_page_about': {
      init: function() {
        function listingHeight(contain_class) {
          var maxHeight = 0;
          $(contain_class).css('height', 'auto');

          $(contain_class).each(function() {
            if ($(this).height() > maxHeight) {
              maxHeight = $(this).height();
            }
          });

          $(contain_class).height(maxHeight);
        }

        listingHeight('.member');

        $(window).on("load resize", function() {
          listingHeight('.member');
        });
      }
    },
    'page_template_page_contact': {
      init: function() {
        //set your google maps parameters
        var $latitude = 54.9039688,
          $longitude = -1.3781995,
          $map_zoom = 15;

        //google map custom marker icon - .png fallback for IE11
        var is_internetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1;
        var $marker_url = '/wp-content/themes/ssc/assets/images/map-marker.png';

        //define the basic color of your map, plus a value for saturation and brightness
        var $main_color = '#D10074',
          $saturation = -15,
          $brightness = 1;

        //we define here the style of the map
        var style = [
          {
            //set saturation for the labels on the map
            elementType: "labels",
            stylers: [
              {
                saturation: $saturation
              }
            ]
          }, {
            //poi stands for point of interest - don't show these lables on the map
            featureType: "poi",
            elementType: "labels",
            stylers: [
              {
                visibility: "off"
              }
            ]
          }, {
            //don't show highways lables on the map
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
              {
                visibility: "off"
              }
            ]
          }, {
            //don't show local road lables on the map
            featureType: "road.local",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          }, {
            //don't show arterial road lables on the map
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          }, {
            //don't show road lables on the map
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },

          //style different elements on the map
          {
            featureType: "transit",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "poi.government",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "poi.sport_complex",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "poi.attraction",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "poi.business",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "transit",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "transit.station",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "landscape",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                hue: $main_color
              }, {
                visibility: "on"
              }, {
                lightness: $brightness
              }, {
                saturation: $saturation
              }
            ]
          }
        ];

        //set google map options
        var map_options = {
          center: new google.maps.LatLng($latitude, $longitude),
          zoom: $map_zoom,
          panControl: false,
          zoomControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          scrollwheel: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: style
        };

        //inizialize the map
        var map = new google.maps.Map(document.getElementById('map-container'), map_options);

        //add a custom marker to the map
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng($latitude, $longitude),
          map: map,
          visible: true,
          icon: $marker_url
        });

        function initialize(latLng) {
          latLng = latLng.split(",");

          var map_options = {
            center: new google.maps.LatLng(latLng[0], latLng[1]),
            zoom: $map_zoom,
            panControl: false,
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: style
          };

          var map = new google.maps.Map(document.getElementById('map-container'), map_options);

          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(latLng[0], latLng[1]),
            map: map,
            visible: true,
            icon: $marker_url
          });
        }
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
